import React from 'react'
import LogsListing from '../../../../../../../../../itrust_common/components/others/listings/LogsListing'
import { Field, FieldArray, change } from 'redux-form'
import { Checkbox } from '../../../../../../../../../itrust_common/components/form'
import EyefinityFormButton from './EyefinityFormButton'
import { useDispatch } from 'react-redux'

export default function EyefinityModuleSelect(props) {
  const { visionInsuranceClaimForm, actionLabel } = props
  const dispatch = useDispatch()

  const LogsHead = [
    { title: '' },
    { title: 'Service', className: 'text-nowrap' },
    { title: 'Availability', className: 'text-nowrap' },
  ]

  const SERVICE_SELECTION_MAP = {
    'Exam': ['Exam'],
    'Lens': ['Lens', 'Contact Lens'],
    'Frame': ['Frame'],
    'Contact Lens': ['Lens', 'Frame', 'Contact Lens'],
  }

  const SERVICE_UNCHECK_MAP = {
    'Lens': ['Contact Lens'],
    'Contact Lens': ['Lens', 'Frame'],
  }

  const RenderEyefinityClaimService = ({ fields }) => {
    const data = visionInsuranceClaimForm?.eligibility?.data || []

    const handleCheckboxChange = (selectedItem, newValue) => {
      const serviceType = selectedItem.service_type
      const relatedServices = newValue
        ? SERVICE_SELECTION_MAP[serviceType]
        : SERVICE_UNCHECK_MAP[serviceType]

      if (!relatedServices) return

      data.forEach((item, idx) => {
        if (!relatedServices.includes(item.service_type)) return
        if (newValue && item.availability === 'No') return

        dispatch(change('EyefinityClaimForm', `eligibility.data[${idx}].active`, newValue))
      })
    }

    return (
      <>
        {data.map((item, index) => (
          <tr key={index}>
            <td>
              <Field
                name={`eligibility.data[${index}].active`}
                component={Checkbox}
                disabled={item.availability === 'No'}
                wrapperClasses="pl-4"
                onChange={(event, newValue) => handleCheckboxChange(item, newValue)}
              />
            </td>
            <td>{item.service_type}</td>
            <td>{item.availability}</td>
          </tr>
        ))}
      </>
    )
  }

  return (
    <LogsListing
      logs={visionInsuranceClaimForm?.visionInsuranceClaimForm?.eligibility?.data}
      TableHead={LogsHead}
    >
      <FieldArray name="eligibility.data" component={RenderEyefinityClaimService} />
      <tr>
        <td colSpan={10}>
          <EyefinityFormButton buttonClasses="py-2" actionLabel={actionLabel} />
        </td>
      </tr>
    </LogsListing>
  )
}